import { controls, currencyToNumber, grouped } from "../../controls";

const department_wise_payment = {
  label: "Department Wise Payments",
  starting: true,
  url: "department_wise_payment",
  pageLabel: "Department Wise Payments",
  pageType: "history",
  visitingBranches: true,
  filter: [
    ...controls.magicDateLabel({ tab: "general", label: "Month", target: "month", star: true }),
    ...controls.magicDate({ tab: "general", name: "salary_month", displayFormat: "MMMM yyyy", dateType: "monthYear", isRequired: true, isReadOnly: "edit" }),
    ...controls.displayText({ tab: "general", label: "" }),
  ],
  form: [],
  history: {
    perPage: 50,
    reportHeader: "Department Wise Payments",
    filterable: true,
    sortable: true,
    defaultsTo: 0,
    pdfProps: {
      pageSize: "A4", pageOrientation: "portrait",
      header: [
        [
          { field: "salary_month" }
        ]
      ],
    },
    extraRows: {
      location: "top",
      fields: ["gross_payment", "deduction", "net_pay"],
      grandtotal: { type: "fixed", displayIn: "department_display", val: "Grand Total", count: true },
    },

    displayColumns: [
      {
        Header: "Sr", type: "autoinc", accessor: "srno", align: "center", width: 30,
        width132: { size: 3 }
      },
      {
        Header: "Department",
        accessor: "department_display",
        rwidth: "*"
      },
      {
        Header: "Gross Pay",
        accessor: "gross_payment"
      },
      {
        Header: "Deduction",
        accessor: "deduction"
      },
      {
        Header: "Net Pay",
        accessor: "net_pay"
      }
    ]
  }
};

export default department_wise_payment;